import { render, staticRenderFns } from "./EventExpand.vue?vue&type=template&id=1049aabc&scoped=true&"
import script from "./EventExpand.vue?vue&type=script&lang=js&"
export * from "./EventExpand.vue?vue&type=script&lang=js&"
import style0 from "./EventExpand.vue?vue&type=style&index=0&id=1049aabc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049aabc",
  null
  
)

export default component.exports